import { makeStyles } from "@material-ui/core";

const accessControlsSettingsStyles = makeStyles((theme) => ({
  root: {
    // paddingLeft: "2%",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    paddingRight: "2.5%",
  },

  grayText: {
    color: theme.palette.text.tertiary,
  },

  tableContainer: {
    width: "100%",
  },
  table: {
    width: "100%",
  },
  tableHeader: {
    backgroundColor: theme.palette.primary.main,
    display: "table",
    width: "100%",
    tableLayout: "fixed",
  },
  tableBody: {
    display: "block",
    overflowY: "auto",
    [theme.breakpoints.down(823)]: {
      height: `calc(100vh - 305px)`,
    },
  },
  tableRow: {
    borderCollapse: "collapse",
  },
  headTable: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    width: "17.5%",
    background: theme.palette.primary.main,
  },
  headTableTwo: {
    padding: "1.3% 0% !important",
    color: theme.palette.text.primary,
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    // width: "50%",
    background: theme.palette.primary.main,
  },

  listText: {
    color: theme.palette.text.primary,
    padding: "1px",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    // borderBottom: `none`,
    width: "17.5%",
  },
  listTextTwo: {
    color: theme.palette.text.primary,
    padding: "6px 2px",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
    // borderBottom: `none`,
    width: "50%",
    overflow: "hidden",
    borderCollapse: "collapse",
  },
  inviteButton: {
    border: `2px solid ${theme.palette.secondary.main}`,
    height: "40px",
    minWidth: "150px",
    textTransform: "none",
    padding: "6px ",
    borderRadius: "7px",
    color: theme.palette.text.secondary,
    "&:hover": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.secondary.light,
    },
    fontSize: "14px !important",
  },

  flexBetween: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));
export default accessControlsSettingsStyles;
